import React, { useCallback, useEffect, useState } from "react";
import PageTableHeader from "../../../../components/pageTableHeader/pageTableHeader";
import { useSelector } from "react-redux";
import PaginationComponent from "../../../../components/table/tablePagination";
import AttendanceReportTable from "./components/table";
import toast from "react-hot-toast";
import { FiFilter } from "react-icons/fi";
import DefaultButton from "../../../../components/buttons/defaultButton";
import { getSessionList } from "../../../../../services/workspace/session.service";
import { DefaultSelectFilter } from "../../../../components/inputs/defaultSelectFilter";
import TeacherPerformanceTable from "./components/table";
import { staffPerformanceReport } from "../../../../../services/workspace/report.service";

const items = [
  { label: "Home", path: "/" },
  { label: "Reports", path: "/reports" },
  { label: "Teacher Performance Reports" },
];

const TeacherPerformanceReports = () => {
  const { limit } = useSelector((state) => state.global);
  const [search, setSearch] = useState("");
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setCurrentPage(1);
  };

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prev) => !prev);
  };

  const fetchData = useCallback(() => {
    // if (selectClass && selectClass.id && selectSection && selectSection.id) {
      setLoading(true);

      staffPerformanceReport({
        // class_id: selectClass.id,
        // section_id: selectSection.id,
        search,
        page: currentPage,
        limit,
      })
        .then((response) => {
       
          setTableData(response.data);
          setTotalData(response.total);
        })
        .catch((error) => {
          toast.error("Failed to fetch session data!");
          console.error("Error fetching data: ", error);
        })
        .finally(() => setLoading(false)); // Ensure loading state is handled correctly
    // }
  }, [search, currentPage, limit]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      fetchData();
    }, 500); // Prevent excessive API calls while typing

    return () => clearTimeout(delayDebounce);
  }, [search, currentPage, limit]);
  return (
    <div className="flex flex-col shadow-md">
      <PageTableHeader
        breadcrumbs={items}
        isSearch={true}
        onSearchChange={handleSearchChange}
        isFilter={false}
        // buttons={
        //   <div className="flex gap-2">
        //     <DefaultButton
        //       icon={<FiFilter />}
        //       iconClass="text-md"
        //       variant="primary"
        //       onClick={toggleFilterVisibility}
        //     />
        //   </div>
        // }
      />

      <div className="flex flex-col">
        {isFilterVisible && (
          <div className="flex flex-row gap-2 px-4 py-2 text-theme font-bold
           items-center bg-white my-1">
            <h2>Filters</h2>

            <DefaultSelectFilter
              className="bg-light hover:bg-bghoverlight px-2 rounded-md flex flex-row gap-1"
              label="User Type"
              options={[
                { label: "Staff", value: "desc" },
                { label: "Students", value: "asc" },
              ]}
              name="sortBy"
              defaultSelect={true}
              // onChange={handleSelectChange}
              // error={isError}
              errorMsg="Please select an option"
            />


            <DefaultSelectFilter
              className="bg-light hover:bg-bghoverlight px-2 rounded-md flex flex-row gap-1"
              label="Class Filter"
              options={[
                { label: "10th", value: "desc" },
                { label: "12th", value: "asc" },
              ]}
              name="sortBy"
              defaultSelect={true}
              // onChange={handleSelectChange}
              // error={isError}
              errorMsg="Please select an option"
            />

            <DefaultSelectFilter
              className="bg-light hover:bg-bghoverlight px-2 rounded-md flex flex-row gap-1"
              label="Date Range"
              options={[
                { label: "From", value: "desc" },
                { label: "To", value: "asc" },
              ]}
              name="sortBy"
              defaultSelect={true}
              // onChange={handleSelectChange}
              // error={isError}
              errorMsg="Please select an option"
            />
          </div>
        )}

        <TeacherPerformanceTable
          setTotalData={setTotalData}
          loading={loading}
          search={search}
        
          data={tableData}
        />

        {/* Pagination component */}
        <PaginationComponent
          itemPerPage={limit}
          currentPage={currentPage}
          totalItems={totalData}
          paginate={setCurrentPage}
        />
      </div>
    </div>
  );
};

export default TeacherPerformanceReports;
